var React = require('react');

function ShareInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.8418 13.0758L9.8418 13.8258L11.3418 13.8258L11.3418 13.0758L9.8418 13.0758ZM11.1221 0.898355C10.8292 0.605461 10.3544 0.605461 10.0615 0.898355L5.2885 5.67133C4.9956 5.96422 4.9956 6.43909 5.2885 6.73199C5.58139 7.02488 6.05626 7.02488 6.34916 6.73199L10.5918 2.48934L14.8344 6.73199C15.1273 7.02488 15.6022 7.02488 15.8951 6.73199C16.188 6.43909 16.188 5.96422 15.8951 5.67133L11.1221 0.898355ZM11.3418 13.0758L11.3418 1.42869L9.8418 1.42869L9.8418 13.0758L11.3418 13.0758Z","fill":"black","key":0}),React.createElement("path",{"d":"M1 11.9473L1 17.8716C1 18.4948 1.50522 19 2.12844 19H19.0551C19.6783 19 20.1835 18.4948 20.1835 17.8716V11.9473","stroke":"black","strokeWidth":"1.5","key":1})]);
}

ShareInline.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = ShareInline;

ShareInline.default = ShareInline;
